import { useQuery } from 'react-query';
import axios from 'axios';
import { MonitorQueueAPI } from '../../constants/API';
import { getMonitorBranchCode, getMonitorToken, queueScreenHeaders } from '../../constants/HeadersAPI';
import { isCreatedTicketsEqual } from './monitorQueueEquality';
import { isAndroidTabloDevice } from '../../utils/QueuePage/tabloDevice';
import { parseMonitorResponse } from '../../utils/QueuePage/parseMonitorResponse';

const POLL_MS = isAndroidTabloDevice() ? 8000 : 4000;

export type CreatedTicketItem = {
  itemId: number;
  itemName: string;
  status: string;
  statusTime: string;
};

export type CreatedTicketsResponse = {
  items: CreatedTicketItem[];
};

/** Poll созданных талонов только когда блок «взятые» включён у этого табло. */
export const useGetCreatedTickets = (enabled = true) => {
  const {
    data: createdTicketsResp,
    isLoading: isLoadingCreatedTickets,
    isSuccess: isCreatedTicketsReceived
  } = useQuery(
    ['monitor-created-tickets', getMonitorToken(), getMonitorBranchCode()],
    async () => {
      const { data } = await axios.get(
        MonitorQueueAPI.getCreatedItems,
        queueScreenHeaders()
      );
      return parseMonitorResponse<CreatedTicketsResponse>(data);
    },
    {
      isDataEqual: isCreatedTicketsEqual,
      enabled: enabled && !!getMonitorToken(),
      refetchInterval: enabled ? POLL_MS : false,
      refetchIntervalInBackground: true,
      staleTime: Math.floor(POLL_MS / 2),
      refetchOnWindowFocus: false
    }
  );

  return { createdTicketsResp, isLoadingCreatedTickets, isCreatedTicketsReceived };
};
